import React from 'react'
import Loader from 'components/Loader'
import styled from 'styled-components'
import { getTheme, toWidth } from 'helpers'
import AspectRatioImage, { AspectRatioImageContainer } from 'components/AspectRatioImage'

export default ({ loading, onClick, width, album }) =>
  loading ? <Loader /> : (
    <AlbumLink onClick={onClick}>
      <Line1 />
      <Line2 />
      <CoverImageContainer>
        <AspectRatioImage src={toWidth(album.imagePath, 300)} />
      </CoverImageContainer>
      <AlbumName>{album.name}</AlbumName>
      <PhotoCount>{album._photoCount || album.photoCount} รูปภาพ</PhotoCount>
    </AlbumLink>
  )

const AlbumLink = styled.div`
  margin-bottom: 10px;
  position: relative;
`
const Line1 = styled.div`
  position: absolute;
  top: -2px;
  left: 0px;
  right: 0px;
  height: 1px;
  background-color: ${getTheme`colorGray100`};
`
const Line2 = styled.div`
  position: absolute;
  top: -5px;
  left: 9px;
  right: 9px;
  height: 1px;
  background-color: ${getTheme`colorGray100`};
`
const CoverImageContainer = styled(AspectRatioImageContainer)`
  padding-bottom: 100%;
  margin-bottom: 5px;
  cursor: pointer;
  transition: opacity 0.3s ease;
  &:hover { opacity: 0.8; }
  border: 1px solid ${getTheme`colorGray100`};
`
const AlbumName = styled.div`
  font-family: ${getTheme`font1`};
  font-size: 14px;
  word-wrap: break-word;
  line-height: 20px;
  max-height: 40px;
  overflow: hidden;
  color: black;
  clear: both;
`
const PhotoCount = styled.div`
  font-family: ${getTheme`font1`};
  font-size: 14px;
  word-wrap: break-word;
  line-height: 20px;
  max-height: 40px;
  overflow: hidden;
  color: ${getTheme`colorGray100`};
  clear: both;
`

export const AlbumItemWrapper = styled.div`
  display: inline-block;
  vertical-align: top;
  @media(min-width: 960px) {
    margin-right: 10px;
    width: calc(16.67% - 8.36px);
    &:nth-child(6n) { margin-right: 0px; }
  }
  @media(min-width: 768px) and (max-width: 959px) {
    margin-right: 10px;
    width: calc(20% - 8px);
    &:nth-child(5n) { margin-right: 0px; }
  }
  @media(min-width: 600px) and (max-width: 767px) {
    margin-right: 5px;
    width: calc(25% - 3.75px);
    &:nth-child(4n) { margin-right: 0px; }
  }
  @media(max-width: 599px) {
    margin-right: 5px;
    width: calc(33.33% - 4px);
    &:nth-child(3n) { margin-right: 0px; }
  }
`



// WEBPACK FOOTER //
// ./src/components/AlbumItem.js